export default {
  sms(state) {
    return state.sms;
  },
};
